export const alphabeticallyBy: <T extends object>(field: keyof T, inverted?: boolean) => (itemA: T, itemB: T) => number = (
	field,
	inverted = false
) => {
	return (itemA, itemB) => {
		if (itemA[field] > itemB[field]) {
			return inverted ? -1 : 1;
		} else if (itemB[field] > itemA[field]) {
			return inverted ? 1 : -1;
		} else {
			return 0;
		}
	};
};
